import { motion } from "framer-motion";

export const MaskedLines = ({ lines, className = "", delay = 0.15, testId }) => (
  <h1 data-testid={testId} className={className}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.08em]">
        <motion.span className="block will-change-transform"
          initial={{ y: "105%", rotate: 2 }} animate={{ y: "0%", rotate: 0 }}
          transition={{ delay: delay + i * 0.12, duration: 1.05, ease: [0.22, 1, 0.36, 1] }}>
          {line}
        </motion.span>
      </span>
    ))}
  </h1>
);

export const Reveal = ({ children, className = "", delay = 0 }) => (
  <motion.div className={className} initial={{ opacity: 0, y: 28 }} whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.1 }} transition={{ delay, duration: 0.8, ease: [0.22, 1, 0.36, 1] }}>
    {children}
  </motion.div>
);
